import { createContext } from "react";

export const APIContext = createContext({
  baseUrl: "",
  currencyCode: "GBP",
  shipToCountryCode: "GB",
  locale: "en-GB",
  storeHash: "",
});
